import { Api } from 'utils';

class SystemMovementService {
	
	static get = async (params?: any) => Api.createResponse('admin/system-movements/',params);

}

export default SystemMovementService;